import { resolveBulkEventsEndPoint, fetchIncidentsByFloorStatsEndPoint, checkResolveBulkStatusEndPoint } from "../configuration";
import axiosInstance from "../global/axiosInterceptor";
import { ERROR_MESSAGES } from "../global/constants/errorConstants";
import { RESOLVE_STATUS } from "../global/constants/constants";

export const resolveBulkEvents = async (filterObject, activeSession) => {
  try {
    const response = await axiosInstance.patch(resolveBulkEventsEndPoint(), {
      accountname: activeSession.accountId,
      ...filterObject,
    });
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export const fetchIncidentsByFloorStats = async (accountname, siteId) => {
  try {
    const response = await axiosInstance.post(fetchIncidentsByFloorStatsEndPoint(), {
      accountname,
      resourceidentifier: {
        siteid: siteId
      }
    });
    return response.data;
  } catch (error) {
    // Non-blocking enhancement (floor-plan event counts) — do not surface an error
    // notification to the user. Rethrow so the saga's own failure handling still runs.
    console.error(ERROR_MESSAGES.INCIDENTS_BY_FLOOR_FETCH_FAILED, error);
    throw error;
  }
};

export const checkResolveBulkStatus = async (accountID) => {
  try {
    const response = await axiosInstance.post(checkResolveBulkStatusEndPoint(), {
      accountname: accountID
    });
    const data = response.data;

    // Transform API response { inProgress: true/false } to expected format
    return {
      status: data.inProgress === true ? RESOLVE_STATUS.IN_PROGRESS : RESOLVE_STATUS.IDLE
    };
  } catch (error) {
    console.error("Status check failed:", error?.message);
    throw error;
  }
};

export const fetchLocationData = (cameraList = []) => {
  
  // Transform location data to match the exact payload structure you described
  const locationData = cameraList
    .filter(camera => camera?.customdata?.location) // Only cameras with location data
    .map(camera => {
      const location = camera.customdata.location;
      return {
        area: {
          name: location?.area?.name || '',
          text: location?.area?.name || '',
          value: location?.area?.name || '',
          id: location?.area?.tag || ''
        },
        blurConfig: {
          name: '',
          text: '',
          value: '',
          id: ''
        },
        floor: {
          name: location?.floor?.name || '',
          text: location?.floor?.name || '',
          value: location?.floor?.name || '',
          id: location?.floor?.tag || ''
        },
        site: {
          name: location?.site?.name || '',
          text: location?.site?.name || '',
          value: location?.site?.name || '',
          id: location?.site?.tag || ''
        },
        subarea: {
          name: location?.subarea?.name || 'NA',
          text: location?.subarea?.name || 'NA',
          value: location?.subarea?.name || 'NA',
          id: location?.subarea?.tag || 'NA'
        }
      };
    })
    // Remove duplicates based on a combination of site, floor, and area IDs
    .filter((location, index, self) => {
      const locationKey = `${location.site.id}_${location.floor.id}_${location.area.id}`;
      return index === self.findIndex(l => 
        `${l.site.id}_${l.floor.id}_${l.area.id}` === locationKey
      );
    });

  return locationData;
};
